import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon, ClockIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { practice } from '../data/site';
import { AppointmentForm } from './AppointmentForm';
import { StylizedMap } from './ui/StylizedMap';
import { Reveal } from './ui/Reveal';
export function BookingSection() {
  return <section id="contact" aria-labelledby="contact-title" className="scroll-mt-24 bg-ink py-24 text-white lg:py-40" data-id="element-96" data-mp="1vqni4mpeonb1">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-97" data-mp="25i1kd28qs17v">
        <Reveal className="max-w-[760px]" data-id="element-98" data-mp="25jvv5nqaucy8">
          <p className="eyebrow flex items-center gap-3 text-accent" data-id="element-99" data-mp="2ji2jod9cz0l8">
            <span aria-hidden="true" className="h-px w-8 bg-accent" data-id="element-100" data-mp="2eigacewni4hp" />
            Book your visit
          </p>
          <h2 id="contact-title" className="font-display mt-7 text-[clamp(2.1rem,4.4vw,3.5rem)] leading-[1.05]" data-id="element-101" data-mp="p39scqficvz3">
            Your next smile
            <br data-id="element-102" data-mp="k6t4zyg4uln2" />
            starts here.
          </h2>
          <p className="mt-7 max-w-[54ch] text-[16.5px] leading-[1.85] text-white/65" data-id="element-103" data-mp="3txhfxr6yn14n">
            Book online in a few seconds, or send us a request below and our team will contact you
            to confirm it.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-104" data-mp="7nwtsf20qpx5">
            <a href={practice.bookingUrl} target="_blank" rel="noreferrer" className="group flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] bg-white px-7 text-[15px] font-medium text-ink transition-all duration-300 hover:shadow-[0_0_0_3px_rgba(255,255,255,0.15)]" data-id="element-105" data-mp="chhljpd0qnnw">
              Book online at lima.dental
              <span className="hover-arrow" data-id="element-106" data-mp="vdheb2dtlv8j">
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-107" data-mp="2s72jib8wjcpu" />
              </span>
            </a>
            <a href={practice.phoneHref} className="flex min-h-[54px] items-center justify-center gap-2.5 rounded-[10px] border border-white/25 px-7 text-[15px] font-medium text-white transition-colors hover:border-white/60" data-id="element-108" data-mp="2x5dskjrdhj70">
              <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-109" data-mp="2z3nilx7gwv08" />
              {practice.phone}
            </a>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-12 lg:mt-20 lg:grid-cols-12 lg:gap-16" data-id="element-110" data-mp="2u2zkysoqhfx1">
          <Reveal className="lg:col-span-7" data-id="element-111" data-mp="383ade05oz2kb">
            <h3 className="eyebrow mb-5 text-white/40" data-id="element-112" data-mp="381z8ty4f9qs5">Appointment request</h3>
            <AppointmentForm surface="glass" source="Website — Contact" data-id="element-113" data-mp="334z1ljvu6hzg" />
          </Reveal>

          <Reveal delay={0.08} className="lg:col-span-5" data-id="element-114" data-mp="3htln63c245z4">
            <div className="border-t border-white/10 pt-8" data-id="element-115" data-mp="3cuinkyeuiryj">
              <h3 className="font-display text-[24px] leading-[1.2] text-white" data-id="element-116" data-mp="3cxei0crhiyi8">
                Lima Dental Group
              </h3>
              <p className="mt-2 text-[15px] text-white/50" data-id="element-117" data-mp="3mtrko050cmp4">Miami Lakes, Florida</p>

              <dl className="mt-9 space-y-7" data-id="element-118" data-mp="9ce0yj5re00p">
                <div className="flex gap-4" data-id="element-119" data-mp="9cnrq8ymob7g">
                  <MapPinIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-accent" strokeWidth={1.5} data-id="element-120" data-mp="eb8qe3y8emts" />
                  <div data-id="element-121" data-mp="5aj01frqpong">
                    <dt className="eyebrow text-white/40" data-id="element-122" data-mp="5a14ymgtdgh4">Address</dt>
                    <dd className="mt-2 text-[16px] leading-relaxed text-white/85" data-id="element-123" data-mp="5cdjsqr9zapy">
                      {practice.address.street}
                      <br data-id="element-124" data-mp="3ri0rhukl3ijw" />
                      {practice.address.city}, {practice.address.region}{' '}
                      {practice.address.postalCode}
                    </dd>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-125" data-mp="3hsh8mowvfop1">
                  <PhoneIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-accent" strokeWidth={1.5} data-id="element-126" data-mp="33s6end09ltzn" />
                  <div data-id="element-127" data-mp="ez9yssh9u7wd">
                    <dt className="eyebrow text-white/40" data-id="element-128" data-mp="ezt4natnd5u1">Phone</dt>
                    <dd className="mt-2 text-[16px] text-white/85" data-id="element-129" data-mp="f147n8f9q9k3">
                      <a href={practice.phoneHref} className="hover:text-white" data-id="element-130" data-mp="ay7w21o5bdpn">
                        {practice.phone}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-131" data-mp="15sgfb0bn17x">
                  <MailIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-accent" strokeWidth={1.5} data-id="element-132" data-mp="3seg1dpungmey" />
                  <div data-id="element-133" data-mp="3jczp1ck9ya83">
                    <dt className="eyebrow text-white/40" data-id="element-134" data-mp="3jej9zggvl9g7">Email</dt>
                    <dd className="mt-2 text-[16px] text-white/85" data-id="element-135" data-mp="3eeogd55pu5rg">
                      <a href={`mailto:${practice.email}`} className="hover:text-white" data-id="element-136" data-mp="3eghrawnd3c59">
                        {practice.email}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-137" data-mp="1k6ucs2gv0dss">
                  <ClockIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-accent" strokeWidth={1.5} data-id="element-138" data-mp="1k61frt7pd2nu" />
                  <div data-id="element-139" data-mp="1txp1ddhkvphe">
                    <dt className="eyebrow text-white/40" data-id="element-140" data-mp="1tx5quhu9c3de">Office hours</dt>
                    <dd className="mt-2 space-y-1 text-[16px] text-white/85" data-id="element-141" data-mp="1yu5qa9wlq7vj">
                      {practice.hours.map(h => <p key={h.day} data-id="element-142" data-mp="119t3w6k6ptjk">
                          <span className="text-white/50" data-id="element-143" data-mp="16602tfe5y4s0">{h.day}:</span> {h.value}
                        </p>)}
                    </dd>
                  </div>
                </div>
              </dl>

              <div className="mt-9 space-y-2.5 border-t border-white/10 pt-8 text-[15px] leading-relaxed text-white/70" data-id="element-144" data-mp="1f89dc59fly5e">
                <p data-id="element-145" data-mp="2mkrxy02p1q50">{practice.walkIns}</p>
                <p data-id="element-146" data-mp="2qmd6584a9g8v">{practice.newPatients}</p>
                <p data-id="element-147" data-mp="2ql20f2ra1yf4">{practice.languages}</p>
                <p data-id="element-148" data-mp="rhv6ikzlk8iu">
                  <span className="font-semibold text-white" data-id="element-149" data-mp="rhdbfroo80ci">Emergencies:</span> if you have
                  dental pain, a broken tooth or an infection, call us directly at{' '}
                  <a href={practice.phoneHref} className="font-medium text-white underline underline-offset-4" data-id="element-150" data-mp="10ib8tr4lt9m4">
                    {practice.phone}
                  </a>
                  .
                </p>
              </div>

              <div className="mt-9 overflow-hidden rounded-[12px] border border-white/10 grayscale" data-id="element-151" data-mp="3sank23g1b9k">
                <StylizedMap data-id="element-152" data-mp="hjp5s6pj18fk" />
              </div>
              <a href={practice.mapsUrl} target="_blank" rel="noreferrer" className="group mt-5 inline-flex min-h-[44px] items-center gap-2 text-[14.5px] font-medium text-white" data-id="element-153" data-mp="hkh25jqy7a6w">
                <span className="nav-link" data-id="element-154" data-mp="3g9z2ndobmm0p">Get directions</span>
                <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 text-accent transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-155" data-mp="3g9fnu5tywdqw" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}